import authModules from './pages/auth';
import loginModules from './pages/auth/LogIn';
import signupModules from './pages/auth/SignUp';
import resetModules from './pages/auth/Reset';
import homeModules from './pages/home';
import serviceModules from './pages/service';
import topModules from './pages/top';
import vasModules from './pages/vas';
import larcModules from './pages/larc';
import phoneModules from './pages/PhoneModule';
import profileModules from './pages/profile';
import AccountModules from './pages/Account';
import eligibilityModules from './pages/eligibility';
import consultationModules from './pages/Consultation';
import bookappointmentModules from './pages/BookAppointment';
import bookvasappointmentModules from './pages/VasAppointment';
import questionnaires from './pages/questionnaires';
import bookcounsellingappointmentModules from './pages/Counselling';
import LarcAppointmentModules from './pages/LarcAppointment';
import TopBookAppointment from './pages/TopAppointment';

export default [
  ...authModules,
  ...loginModules,
  ...signupModules,
  ...resetModules,
  ...homeModules,
  ...serviceModules,
  ...topModules,
  ...larcModules,
  ...phoneModules,
  ...profileModules,
  ...eligibilityModules,
  ...consultationModules,
  ...bookappointmentModules,
  ...questionnaires,
  ...vasModules,
  ...AccountModules,
  ...bookvasappointmentModules,
  ...bookcounsellingappointmentModules,
  ...LarcAppointmentModules,
  ...TopBookAppointment,
];
